import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for button style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiCheckboxStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      flex: '0 0 18px',
      padding: 0,
      height: 18,

      '& svg': {
        width: '100%',
        height: '100%',
      },
    },

    colorPrimary: {},

    indeterminate: {
      color: theme.palette.primary.main,
    },
  };
};
